/** Format a dashboard last-refresh timestamp for display in the header. */
export function formatDashboardLastRefreshed(value: Date): string {
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(value);
}
